import React, { Suspense, lazy } from "react";
import { Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

const componentMap = {
  nebulization: lazy(() => import("./AiNebulisation")),
  blood_products: lazy(() => import("./AiBloodProducts")),
  iv_fluids: lazy(() => import("./AiIvFluids")),
  parental_nutrition: lazy(() => import("./AiParentalNutrition")),
  respiratory_care_respiratory_support: lazy(() =>
    import("./AiRespiratoryCare/AiRespiratorySupport")
  ),
  respiratory_care_tracheostomy_care: lazy(() =>
    import("./AiRespiratoryCare/AiTracheostomy")
  ),
  respiratory_care_chest_physiotherapy: lazy(() =>
    import("./AiRespiratoryCare/AiChestPhysiotherapy")
  ),
  urinary_catheter_care: lazy(() => import("./AiUrinaryCatheter")),
  open_wound_care: lazy(() => import("./AiWoundCare")),
  feeding_tube: lazy(() => import("./AiFeedingTube")),
  pressure_sore: lazy(() => import("./AiPressureSore")),
  ostomy_care: lazy(() => import("./AiOstomy")),
  preventive_care_pressure_sore_care: lazy(() =>
    import("./AiPreventiveCare/AiPressureSore")
  ),
  position_change_schedule: lazy(() =>
    import("./AiPreventiveCare/AiPositionChange")
  ),
  preventive_care_thromboprophylaxis: lazy(() =>
    import("./AiPreventiveCare/AiThromboprophyl")
  ),
  preventive_care_central_line_care: lazy(() =>
    import("./AiPreventiveCare/AiCentralLine")
  ),
  eye_care_saline_wash: lazy(() => import("./AiEyeCare/AiSalineWash")),
  eye_care_eye_drops: lazy(() => import("./AiEyeCare/AiEyeDrops")),
  eye_care_eye_gel_ointment: lazy(() => import("./AiEyeCare/AiEyeGel")),
  eye_care_trasorrhaphy: lazy(() => import("./AiEyeCare/AiTarsorrhaphy")),
  eye_care_eye_patching_guard: lazy(() => import("./AiEyeCare/AiEyeGuard")),
};

const AiCareItems = ({ editData, form, setEditData }) => {
  const careItems = editData?.care_items || {};

  const handleDelete = (key) => {
    const updated = { ...careItems };
    delete updated[key];

    setEditData((prev) => ({
      ...prev,
      care_items: updated,
    }));
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {Object.keys(careItems).map((key) => {
        const Component = componentMap[key];
        if (!Component) return null;

        return (
          <div
            key={key}
            style={{
              marginBottom: "12px",
              border: "1px solid #EAECF0",
              borderRadius: "8px",
              padding: "12px",
            }}
          >
            <div className="flex-between" style={{ marginBottom: "12px" }}>
              <h4 style={{ margin: 0, textTransform: "capitalize" }}>
                {key.replaceAll("_", " ")}
              </h4>

              <DeleteOutlined
                onClick={() => handleDelete(key)}
                style={{
                  color: "red",
                  fontSize: "20px",
                  cursor: "pointer",
                  marginTop: "30px",
                }}
              />
            </div>

            <Component form={form} data={careItems[key]} />
          </div>
        );
      })}
    </Suspense>
  );
};

export default AiCareItems;
